import * as Dialog from '@radix-ui/react-dialog';

import { Button } from '@/components/Button/Button';

import styles from './ResetConversationDialog.module.css';

interface ResetConversationDialogProps {
  isResetting: boolean;
  onConfirm: () => void;
  onOpenChange: (nextOpen: boolean) => void;
  open: boolean;
}

// Reset hard-deletes the conversation server-side, so the confirmation says so
// plainly rather than hiding behind "clear". Follows the repo's existing
// destructive-confirm shape (see DeleteQuestionDialog): a Radix Dialog with a
// role="alert" warning, rather than pulling in another Radix package.
export function ResetConversationDialog({
  isResetting,
  onConfirm,
  onOpenChange,
  open,
}: ResetConversationDialogProps) {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          <div>
            <Dialog.Title className={styles.title}>
              Clear this conversation?
            </Dialog.Title>
            <Dialog.Description asChild>
              <p className={styles.description}>
                Your whole conversation with the assistant for this chapter will
                be deleted.
              </p>
            </Dialog.Description>
          </div>

          <div className={styles.warning} role="alert">
            <strong>This cannot be undone.</strong>
            <span>Your next question will start a fresh conversation.</span>
          </div>

          <div className={styles.footer}>
            <Dialog.Close asChild>
              <Button disabled={isResetting} variant="secondary">
                Keep it
              </Button>
            </Dialog.Close>
            <Button destructive disabled={isResetting} onClick={onConfirm}>
              {isResetting ? 'Clearing…' : 'Clear conversation'}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
